module.exports = __webpack_public_path__ + "static/media/Data Migration Tool from Civil 3D to BIM 360.9bb87e94.png";